import type { ButtonHTMLAttributes } from 'react'
import { Loader2 } from 'lucide-react'

const variantClass = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
  inverse: 'btn-inverse',
  brand: 'btn-brand',
  danger:
    'inline-flex items-center justify-center gap-1.5 rounded-md bg-danger px-3.5 py-1.5 text-[12.5px] font-medium text-white transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-40',
} as const

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof variantClass
  loading?: boolean
}

export function Button({ variant = 'primary', loading, className = '', children, disabled, type = 'button', ...rest }: ButtonProps) {
  return (
    <button type={type} className={`${variantClass[variant]} ${className}`} disabled={disabled || loading} {...rest}>
      {loading && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
      {children}
    </button>
  )
}
